module.exports = __webpack_public_path__ + "img/item2-3.24121740.jpg";